import { UserIcon } from "@heroicons/react/24/solid";
import AnswerBubble from "../messages/AnswerBubble";

const renderPrivateThread = ({
  messages,
  onToggleLike,
  onToggleDislike,
  onToggleCatalog,
  onOpenSidebar,
  onRetry,
  onSourceClick,
  isRightOpen,
  isStreaming,
  activeSourceId,
  citationInteractions,
  onOpenInEditor,
}) => {
  const lastAnswerIdx = messages.reduce(
    (acc, m, i) => (m.type === "answer" ? i : acc),
    -1,
  );
  const renderedThread = [];

  for (let idx = 0; idx < messages.length; idx++) {
    const entry = messages[idx];

    if (entry.type === "question") {
      const next = messages[idx + 1];
      if (next && next.type === "answer") {
        renderedThread.push(
          <div key={entry.id} className="group/qa flex gap-3">
            <div className="flex flex-col items-center flex-shrink-0">
              <div className="h-8 w-8 rounded-full bg-surface/80 border border-inputBorder flex items-center justify-center">
                <UserIcon className="h-4 w-4 text-mutedText" />
              </div>
              <div className="flex-1 w-px bg-surfaceBorder mt-1.5 mb-1" />
            </div>
            <div className="flex-1 min-w-0 flex flex-col gap-4">
              <div className="pt-1 pb-1 max-w-[720px]">
                <p className="text-sm font-normal leading-relaxed text-mainText">
                  {entry.question}
                </p>
              </div>
              <AnswerBubble
                entry={next}
                onToggleLike={onToggleLike}
                onToggleDislike={onToggleDislike}
                onToggleCatalog={onToggleCatalog}
                onOpenSidebar={onOpenSidebar}
                onRetry={onRetry}
                onSourceClick={onSourceClick}
                isRightOpen={isRightOpen}
                isNewest={idx + 1 === lastAnswerIdx}
                isStreaming={isStreaming}
                activeSourceId={activeSourceId}
                citationInteractions={citationInteractions}
                onOpenInEditor={onOpenInEditor}
              />
            </div>
          </div>,
        );
        idx++;
      } else {
        renderedThread.push(
          <div
            key={entry.id}
            className="group/qa flex gap-3"
            data-orphan-question="true"
          >
            <div className="flex flex-col items-center flex-shrink-0">
              <div className="h-8 w-8 rounded-full bg-surface/80 border border-inputBorder flex items-center justify-center">
                <UserIcon className="h-4 w-4 text-mutedText" />
              </div>
              <div className="flex-1 w-px bg-surfaceBorder mt-1.5 mb-1" />
            </div>
            <div className="flex-1 min-w-0 pt-1 pb-1 max-w-[720px]">
              <p className="text-sm font-normal leading-relaxed text-mainText">
                {entry.question}
              </p>
            </div>
          </div>,
        );
      }
    } else {
      renderedThread.push(
        <div key={entry.id} className="group/qa">
          <AnswerBubble
            entry={entry}
            onToggleLike={onToggleLike}
            onToggleDislike={onToggleDislike}
            onToggleCatalog={onToggleCatalog}
            onOpenSidebar={onOpenSidebar}
            onRetry={onRetry}
            onSourceClick={onSourceClick}
            isRightOpen={isRightOpen}
            isNewest={idx === lastAnswerIdx}
            isStreaming={isStreaming}
            activeSourceId={activeSourceId}
            citationInteractions={citationInteractions}
            onOpenInEditor={onOpenInEditor}
          />
        </div>,
      );
    }
  }

  return renderedThread;
};

export default renderPrivateThread;
